module.exports = __webpack_public_path__ + "media/images/pages/fcr/lab-slide-2-9f5e4b23d9e1bc39010d4234a79d78c9.png";